import React from 'react';
import { LogIn, Loader2, AlertCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const AdminLogin = ({ loginData, setLoginData, loginError, loading, onSubmit }) => {
  return (
    <div className="min-h-screen bg-[#f8f6f1] flex items-center justify-center p-4">
      <div className="bg-white p-8 max-w-md w-full shadow-lg border-t-4 border-[#c5a572]">
        <div className="text-center mb-8">
          <div className="w-16 h-16 mx-auto mb-4 border-2 border-[#c5a572] flex items-center justify-center">
            <LogIn className="w-8 h-8 text-[#c5a572]" />
          </div>
          <h1 className="text-2xl text-[#1a2f23]">Admin Login</h1>
          <p className="text-sm text-[#5a6d62] mt-2">Fatimia Community Services</p>
        </div>
        {loginError && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-6 flex items-center gap-2">
            <AlertCircle className="w-5 h-5" />{loginError}
          </div>
        )}
        <form onSubmit={onSubmit} className="space-y-5">
          <div>
            <Label htmlFor="username" className="text-sm uppercase tracking-wider text-[#5a6d62]">Username</Label>
            <Input 
              id="username" 
              value={loginData.username} 
              onChange={(e) => setLoginData({ ...loginData, username: e.target.value })} 
              className="mt-2" 
              required 
            />
          </div>
          <div>
            <Label htmlFor="password" className="text-sm uppercase tracking-wider text-[#5a6d62]">Password</Label>
            <Input 
              id="password" 
              type="password" 
              value={loginData.password} 
              onChange={(e) => setLoginData({ ...loginData, password: e.target.value })} 
              className="mt-2" 
              required 
            />
          </div>
          <Button type="submit" className="w-full btn-primary" disabled={loading}>
            {loading ? <><Loader2 className="w-5 h-5 animate-spin" /> Logging in...</> : <><LogIn className="w-5 h-5" /> Login</>}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
